import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ChatInterface from '../components/ChatInterface';
import { digitalEmployees } from '../data';

const ChatPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  
  const employee = digitalEmployees.find(emp => emp.id === id);
  
  if (!employee) {
    return <Navigate to="/employees" />;
  }
  
  return (
    <div className="chat-page">
      <ChatInterface employee={employee} />
    </div>
  );
};

export default ChatPage;
